var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 138,
    viewBox: "0 0 138 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4603_14798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.74997 49.6596H31.325V138.157H1.74997V49.6596ZM16.7355 7C6.61316 7 0 13.6078 0 22.2807C0 30.7752 6.41963 37.5751 16.3484 37.5751H16.537C26.8528 37.5751 33.2771 30.7749 33.2771 22.2807C33.0835 13.6078 26.8532 7 16.7355 7ZM103.94 47.5807C88.2411 47.5807 81.2081 56.1667 77.2846 62.1881V49.6596H47.7007C48.0923 57.9617 47.7007 138.157 47.7007 138.157H77.2846V88.7338C77.2846 86.0868 77.4781 83.4496 78.2565 81.5533C80.3985 76.2691 85.2659 70.797 93.4306 70.797C104.143 70.797 108.421 78.9161 108.421 90.8075V138.157H138V87.4107C138 60.2284 123.411 47.5807 103.94 47.5807Z",
    fill: "#6E7277"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4603_14798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 138,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.2c8d0631b0797cade4c8f3afb4bd233a.svg";
export { ForwardRef as ReactComponent };